module.exports = __webpack_public_path__ + "img/b43a54f4a27f460c7c1f9fcf4d44f8e.2060eb4f.jpg";